// hooks/useLoanTypeFilters.ts
import {useMemo} from 'react';

// Map carousel values to actual months
export const repaymentTimeMap: Record<string, number> = {
  'three-months': 3,
  'four-months': 4,
  'five-months': 5,
  'six-months': 6,
  'twelve-months': 12,
  'eighteen-months': 18,
  'twenty-four-months': 24,
  'thirty-months': 30,
  'thirty-six-months': 36,
};
export const repaymentTimeReverseMap: Record<number, string> = {
  3: 'three-months',
  4: 'four-months',
  5: 'five-months',
  6: 'six-months',
  12: 'twelve-months',
  18: 'eighteen-months',
  24: 'twenty-four-months',
  30: 'thirty-months',
  36: 'thirty-six-months',
};
interface IUseLoanTypeFilters {
  searchParams: URLSearchParams | undefined;
  data: ILoanType[] | undefined;
}

const useLoanTypeFilters = ({searchParams, data}: IUseLoanTypeFilters) => {
  const filters = useMemo(() => {
    const amountParam = searchParams?.get('amount');
    const repaymentTimeParam = searchParams?.get('repaymentTime');

    return {
      amount: amountParam ? Number(amountParam) * 1000000 : null, // Convert to actual amount
      repaymentTime: repaymentTimeParam
        ? repaymentTimeMap[repaymentTimeParam]
        : null,
    };
  }, [searchParams]);

  const hasFilters = Object.values(filters).some(value => value !== null);

  const filteredLoans = useMemo(() => {
    if (!data) return [];

    return data
      .filter(item => {
        // Filter by exact amount match (if amount filter is set)
        if (filters.amount !== null && item.amount !== filters.amount) {
          return false;
        }

        // Filter by exact repayment time match (if repayment time filter is set)
        if (
          filters.repaymentTime !== null &&
          item.total_repayment_time !== filters.repaymentTime
        ) {
          return false;
        }

        return true;
      })
      .sort((a, b) => a.amount - b.amount);

    //  to filter all the loan with the amounts larger than the filtered amount
    //   return data
    // .filter(item => {
    //   if (filters.amount !== null && item.amount > filters.amount) {
    //     return false;
    //   }

    //   if (
    //     filters.repaymentTime !== null &&
    //     item.total_repayment_time !== filters.repaymentTime
    //   ) {
    //     return false;
    //   }
    //   return true;
    // })
    // .sort((a, b) => a.amount - b.amount);
  }, [data, filters]);

  return {filteredLoans, hasFilters};
};

export default useLoanTypeFilters;
